import React from "react";
import { AlertCircle, Info } from "lucide-react";

const RegimeSelector = ({ regime, setRegime }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
      <h2 className="text-lg font-semibold mb-1">Tax Regime</h2>
      <p className="text-sm text-gray-500 mb-4">Select your preferred tax regime</p>

      <div className="flex gap-4 mb-4">
        {/* New Regime Option */}
        <div
          onClick={() => setRegime("new")}
          className={`flex-1 border rounded-lg p-4 cursor-pointer flex items-start gap-3 transition-colors ${
            regime === "new" ? "border-blue-500 bg-blue-50" : "border-gray-200 hover:border-blue-300"
          }`}
        >
          <div className="mt-1">
            <input
              type="radio"
              checked={regime === "new"}
              readOnly
              className="w-4 h-4 text-blue-600 focus:ring-blue-500 border-gray-300"
            />
          </div>
          <div>
            <h3 className="font-medium text-gray-900">New Tax Regime</h3>
            <p className="text-xs text-gray-500">Annual tax</p>
          </div>
        </div>

        {/* Old Regime Option */}
        <div
          onClick={() => setRegime("old")}
          className={`flex-1 border rounded-lg p-4 cursor-pointer flex items-start gap-3 transition-colors ${
            regime === "old" ? "border-blue-500 bg-blue-50" : "border-gray-200 hover:border-blue-300"
          }`}
        >
          <div className="mt-1">
            <input
              type="radio"
              checked={regime === "old"}
              readOnly
              className="w-4 h-4 text-blue-600 focus:ring-blue-500 border-gray-300"
            />
          </div>
          <div>
            <h3 className="font-medium text-gray-900">Old Tax Regime</h3>
            <p className="text-xs text-gray-500">Annual tax</p>
          </div>
        </div>
      </div>
      
      <p className="text-xs text-gray-500 text-center mb-6">
        You can review and compare details of both tax regimes in the summary below.
      </p>

      {/* Messages based on regime */}
      {regime === "new" ? (
        <div className="bg-red-50 border border-red-100 rounded-lg p-4 flex gap-3">
          <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
          <div>
            <h4 className="text-sm font-semibold text-red-700">Deductions are not claimable under the new regime</h4>
            <p className="text-xs text-red-600 mt-1 mb-3">
              Section 115BAC allows only the ₹75,000 standard deduction. These fields are locked — switch to the old regime to declare 80C, 80D, HRA and home loan interest.
            </p>
            <button
              onClick={() => setRegime("old")}
              className="bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium py-1.5 px-4 rounded"
            >
              Switch to old regime
            </button>
          </div>
        </div>
      ) : (
        <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 flex gap-3">
          <Info className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
          <div>
            <h4 className="text-sm font-semibold text-blue-900">You are on the old regime for FY 2026-27.</h4>
            <p className="text-xs text-blue-700 mt-1">
              Declare eligible investments and exemptions to help us calculate your TDS.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegimeSelector;
